import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import LoginRecoverForm from 'components/auth/LoginRecoverForm/component';

export default styled(LoginRecoverForm)`
  padding: ${gridSizes('L')} ${gridSizes('L')} 32px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.27);
  background: var(--white);
  border: 1px solid var(--grey-mouse);
  border-radius: ${gridSizes('S')};
  color: var(--grey900)};
  font-size: ${gridSizes('M')};

  ${media.lessThan('extraSmall')`
    border: none;
    box-shadow: none;
    border-radius: 0;
    border-bottom: 1px solid var(--grey-mouse);
    padding: 0 0 32px;
  `};

  .title {
    font-weight: ${weights('medium')};
    font-size: ${gridSizes('L')};
    margin: 0;
    &.error {
      color: var(--red-cherry-text);
    }
    &.success {
      color: #4ca202;
    }
  }
  .form {
    margin: 18px 0 0;
    div input {
      border: 1px solid var(--grey500);
    }
  }
  .form-error {
    div input {
      border: 1px solid var(--red-cherry-text);
    }
  }

  .error-field {
    color: var(--red-cherry-text);
  }

  .error-msg {
    font-size: 14px;
    color: var(--red-cherry-text);
    margin: ${gridSizes('S')} 0 0;
  }
  button {
    margin: ${gridSizes('M')} 0 0;
    width: 100%;
  }
  a {
    display: block;
    color: #0094e4;
    text-decoration: none;
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:hover {
      text-decoration: underline;
    }
  }
`;
